module.exports = __webpack_public_path__ + "static/img/avatar.e186258.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar.png
// module id = 0gU3
// module chunks = 1